<template>
  <v-card 
    @click="onClicked" 
    :class="['hover-item', { 'active-card': active }]"
    flat
    outlined
  >
    <v-card-title
      class="d-flex flex-row"
      :class="{
        'pt-1 pb-1 pr-2': $vuetify.breakpoint.xs,
        'py-0': $vuetify.breakpoint.smAndUp
      }"
    >
      <div class="ml-2 mr-1" :class="{ 'active-icon-wrapper': active }">
        <v-img :src="icon" :width="30" :height="30" contain :class="{ 'active-icon': active }" />
      </div>
      <div class="d-flex flex-column ml-3 align-left py-3">
        <span :class="['app-bold-font font-12', { 'active-title': active }]">
          {{ title }}
          <span v-if="active" class="active-indicator">●</span>
        </span>
        <div class="d-none align-center mb-1">
          <div>
            <v-img
              :src="require('@/assets/svg/eye.svg')"
              :width="$vuetify.breakpoint.xs ? 15 : 15"
              :height="$vuetify.breakpoint.xs ? 8 : 8"
              contain
            />
          </div>
          <div
            class="gray-font-color ml-2 mt-1 line-height-15"
            :class="$vuetify.breakpoint.xs ? 'font-8' : 'font-8'"
          >
            {{ text }}
          </div>
        </div>
      </div>
      <div class="flex-grow d-flex justify-end align-center">
        <v-icon 
          :color="active ? '#F0A000' : '#D6D6D8'" 
          size="20"
          :class="{ 'active-arrow': active }"
        >
          mdi-arrow-right
        </v-icon>
      </div>
    </v-card-title>
    <v-card-title
      v-if="$vuetify.breakpoint.smAndUp && showSeperator"
      class="py-0"
    >
      <div 
        :style="{
          height: '1px', 
          backgroundColor: active ? '#F0A000' : '#E8EDF0', 
          width: '100%',
          opacity: active ? '1' : '0.6'
        }"
      ></div>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  props: {
    onClicked: Function,
    icon: String,
    title: String,
    text: String,
    top: {
      type: Boolean,
      default: true
    },
    showSeperator: {
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
/* Active state - Solid background color */
.active-card {
  background: #FFF8F0 !important;
  border-left: 4px solid #F0A000 !important;
  border-radius: 8px 0 0 8px !important;
  transition: all 0.3s ease;
  position: relative;
  box-shadow: 0 2px 8px rgba(240, 160, 0, 0.12) !important;
}

.active-card:hover {
  background: #e6f0ff !important;
  box-shadow: 0 4px 12px rgba(240, 160, 0, 0.2) !important;
}

.active-title {
  color: #225678 !important;
  font-weight: 700 !important;
  letter-spacing: 0.3px;
}

.active-indicator {
  color: #F0A000;
  font-size: 10px;
  margin-left: 4px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

.active-icon {
  filter: brightness(0) saturate(100%) invert(77%) sepia(49%) saturate(7496%) hue-rotate(1deg) brightness(99%) contrast(103%);
}

.active-icon-wrapper {
  position: relative;
}

.active-arrow {
  color: #225678 !important;
}

/* Hover effect - Solid background change */
.hover-item:hover {
  background: rgba(244, 242, 239, 0.04) !important;
}

.hover-item:hover .active-title {
  color: #F0A000 !important;
}

.hover-item:hover .active-icon {
  filter: brightness(0) saturate(100%) invert(77%) sepia(49%) saturate(7496%) hue-rotate(1deg) brightness(99%) contrast(103%);
}

.hover-item:hover .v-icon {
  color: #F0A000 !important;
}

/* Ensure solid background on active state */
.active-card.v-card {
  background: #FFF8F0 !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .active-card {
    border-left-width: 3px;
    border-radius: 6px 0 0 6px !important;
  }
  
  .active-title {
    font-size: 11px;
  }
  
  .active-indicator {
    font-size: 8px;
  }
}

@media (max-width: 400px) {
  .active-card {
    border-left-width: 3px;
  }
}
</style>